import IconFacebook from 'views/components/atoms/Icon/IconFacebook'
import IconMail from 'views/components/atoms/Icon/IconMail'
import IconPinterest from 'views/components/atoms/Icon/IconPinterest'
import IconTwitter from 'views/components/atoms/Icon/IconTwitter'
import IconWhatsapp from 'views/components/atoms/Icon/IconWhatsapp'

export const getUrl = (url, params) => {
  const queryParams = []

  // Note: Could be replaced with `genQueryString` util call
  // if args like `media=false` is fine (this version drops such values)
  Object.keys(params).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(params, key) && params[key]) {
      queryParams.push(`${key}=${encodeURIComponent(params[key])}`)
    }
  })

  return `${url}?${queryParams.join('&')}`
}

export const getIcons = ({
  i18n,
  url,
  productId,
  productName,
  productMedia,
}) => {
  const facebook = {
    id: 'facebook',
    Icon: IconFacebook,
    label: i18n._('social.links.label.facebook', {}, { defaults: 'Facebook' }),
    url: getUrl('https://www.facebook.com/sharer/sharer.php', {
      u: `${url}?campaign=share/facebook/desktop/${productId}`,
    }),
    mobileUrl: getUrl('https://www.facebook.com/sharer/sharer.php', {
      u: `${url}?campaign=share/facebook/mobile/${productId}`,
    }),
  }

  const twitter = {
    id: 'twitter',
    Icon: IconTwitter,
    label: i18n._('social.links.label.twitter', {}, { defaults: 'Twitter' }),
    url: getUrl('https://twitter.com/intent/tweet', {
      url: `${url}?campaign=share/twitter/desktop/${productId}`,
      text: productName,
    }),
    mobileUrl: getUrl('https://twitter.com/intent/tweet', {
      url: `${url}?campaign=share/twitter/mobile/${productId}`,
      text: productName,
    }),
  }

  const pinterest = {
    id: 'pinterest',
    Icon: IconPinterest,
    label: i18n._(
      'social.links.label.pinterest',
      {},
      { defaults: 'Pinterest' }
    ),
    url: getUrl('https://www.pinterest.com/pin/create/link/', {
      url: `${url}?campaign=share/pinterest/desktop/${productId}`,
      description: productName,
      media: productMedia.length > 0 && productMedia[0],
    }),
    mobileUrl: getUrl('https://www.pinterest.com/pin/create/link/', {
      url: `${url}?campaign=share/pinterest/mobile/${productId}`,
      description: productName,
      media: productMedia.length > 0 && productMedia[0],
    }),
  }

  const mail = {
    id: 'mail',
    Icon: IconMail,
    label: i18n._('social.links.label.mail', {}, { defaults: 'Mail' }),
    url: getUrl('mailto:', {
      subject: i18n._('shareBox.label.userMessage', {
        url: `${url}?campaign=share/mail/desktop/${productId}`,
      }),
    }),
    mobileUrl: getUrl('mailto:', {
      subject: i18n._('shareBox.label.userMessage', {
        url: `${url}?campaign=share/mail/mobile/${productId}`,
      }),
    }),
  }

  const whatsapp = {
    id: 'whatsapp',
    Icon: IconWhatsapp,
    label: i18n._('social.links.label.whatsapp', {}, { defaults: 'Whatsapp' }),
    url: getUrl('whatsapp://send', {
      text: `${url}?campaign=share/whatsapp/desktop/${productId}`,
    }),
    mobileUrl: getUrl('whatsapp://send', {
      text: `${url}?campaign=share/whatsapp/mobile/${productId}`,
    }),
    mobileOnly: true,
  }

  return [whatsapp, facebook, twitter, pinterest, mail]
}
